/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pending_BannerInputs */

const th_pending_banner = /** @type {(inputs: Pending_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บัญชีผู้ตัดสินของคุณกำลังรอผู้ดูแลระบบอนุมัติ ระหว่างนี้คุณสามารถดูรอบ ๆ ได้`)
};

const en_pending_banner = /** @type {(inputs: Pending_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your referee account is waiting for an administrator to approve it. You can look around in the meantime.`)
};

const ja_pending_banner = /** @type {(inputs: Pending_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`審判アカウントは管理者の承認待ちです。その間も自由にご覧いただけます。`)
};

const zh_pending_banner = /** @type {(inputs: Pending_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的裁判账户正在等待管理员批准。在此期间你可以先浏览。`)
};

const es_pending_banner = /** @type {(inputs: Pending_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu cuenta de árbitro está pendiente de que un administrador la apruebe. Mientras tanto puedes echar un vistazo.`)
};

const pt_pending_banner = /** @type {(inputs: Pending_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua conta de árbitro aguarda a aprovação de um administrador. Enquanto isso, você pode dar uma olhada.`)
};

const id_pending_banner = /** @type {(inputs: Pending_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akun wasit Anda menunggu persetujuan administrator. Sementara itu Anda bisa melihat-lihat.`)
};

const fr_pending_banner = /** @type {(inputs: Pending_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre compte d’arbitre attend l’approbation d’un administrateur. Vous pouvez regarder en attendant.`)
};

const tl_pending_banner = /** @type {(inputs: Pending_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naghihintay ng pag-apruba ng administrador ang referee account mo. Samantala, maaari kang mamasyal.`)
};

const vi_pending_banner = /** @type {(inputs: Pending_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài khoản trọng tài của bạn đang chờ quản trị viên duyệt. Trong lúc đó bạn có thể xem quanh.`)
};

const ko_pending_banner = /** @type {(inputs: Pending_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`심판 계정이 관리자 승인을 기다리고 있습니다. 그동안 둘러보실 수 있습니다.`)
};

const de_pending_banner = /** @type {(inputs: Pending_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Schiedsrichterkonto wartet auf die Freigabe durch einen Administrator. Bis dahin kannst du dich umsehen.`)
};

const ru_pending_banner = /** @type {(inputs: Pending_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваш судейский аккаунт ждёт одобрения администратора. Пока можно осмотреться.`)
};

const tr_pending_banner = /** @type {(inputs: Pending_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakem hesabınız yönetici onayı bekliyor. Bu arada gezinebilirsiniz.`)
};

const it_pending_banner = /** @type {(inputs: Pending_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo account da arbitro attende l'approvazione di un amministratore. Nel frattempo puoi dare un'occhiata.`)
};

const pl_pending_banner = /** @type {(inputs: Pending_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoje konto sędziego czeka na zatwierdzenie przez administratora. W międzyczasie możesz się rozejrzeć.`)
};

const uk_pending_banner = /** @type {(inputs: Pending_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваш обліковий запис судді чекає на схвалення адміністратора. Тим часом можна роздивитися.`)
};

const hi_pending_banner = /** @type {(inputs: Pending_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपका रेफ़री खाता व्यवस्थापक की स्वीकृति की प्रतीक्षा में है। तब तक आप देख सकते हैं।`)
};

const ar_pending_banner = /** @type {(inputs: Pending_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حساب الحكم الخاص بك بانتظار موافقة مشرف. يمكنك التصفّح في هذه الأثناء.`)
};

const ms_pending_banner = /** @type {(inputs: Pending_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akaun pengadil anda menunggu kelulusan pentadbir. Sementara itu anda boleh melihat-lihat.`)
};

const bn_pending_banner = /** @type {(inputs: Pending_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার রেফারি অ্যাকাউন্ট প্রশাসকের অনুমোদনের অপেক্ষায়। ততক্ষণ আপনি ঘুরে দেখতে পারেন।`)
};

const zh_tw2_pending_banner = /** @type {(inputs: Pending_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的裁判帳戶正在等待管理者核准。在此期間你可以先瀏覽。`)
};

const zh_hk2_pending_banner = /** @type {(inputs: Pending_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的裁判帳戶正在等待管理者核准。在此期間你可以先瀏覽。`)
};

const ur_pending_banner = /** @type {(inputs: Pending_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آپ کا ریفری اکاؤنٹ منتظم کی منظوری کے انتظار میں ہے۔ اس دوران آپ دیکھ سکتے ہیں۔`)
};

const fa_pending_banner = /** @type {(inputs: Pending_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حساب داوری شما در انتظار تأیید مدیر است. تا آن زمان می‌توانید بگردید.`)
};

const sw_pending_banner = /** @type {(inputs: Pending_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akaunti yako ya urefa inasubiri idhini ya msimamizi. Wakati huo unaweza kuangalia.`)
};

const nl_pending_banner = /** @type {(inputs: Pending_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je scheidsrechtersaccount wacht op goedkeuring van een beheerder. Ondertussen kun je rondkijken.`)
};

/**
* | output |
* | --- |
* | "Your referee account is waiting for an administrator to approve it. You can look around in the meantime." |
*
* @param {Pending_BannerInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const pending_banner = /** @type {((inputs?: Pending_BannerInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pending_BannerInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_pending_banner(inputs)
	if (locale === "ja") return ja_pending_banner(inputs)
	if (locale === "zh") return zh_pending_banner(inputs)
	if (locale === "es") return es_pending_banner(inputs)
	if (locale === "pt") return pt_pending_banner(inputs)
	if (locale === "id") return id_pending_banner(inputs)
	if (locale === "fr") return fr_pending_banner(inputs)
	if (locale === "tl") return tl_pending_banner(inputs)
	if (locale === "vi") return vi_pending_banner(inputs)
	if (locale === "ko") return ko_pending_banner(inputs)
	if (locale === "de") return de_pending_banner(inputs)
	if (locale === "ru") return ru_pending_banner(inputs)
	if (locale === "tr") return tr_pending_banner(inputs)
	if (locale === "it") return it_pending_banner(inputs)
	if (locale === "pl") return pl_pending_banner(inputs)
	if (locale === "uk") return uk_pending_banner(inputs)
	if (locale === "hi") return hi_pending_banner(inputs)
	if (locale === "ar") return ar_pending_banner(inputs)
	if (locale === "ms") return ms_pending_banner(inputs)
	if (locale === "bn") return bn_pending_banner(inputs)
	if (locale === "zh-TW") return zh_tw2_pending_banner(inputs)
	if (locale === "zh-HK") return zh_hk2_pending_banner(inputs)
	if (locale === "ur") return ur_pending_banner(inputs)
	if (locale === "fa") return fa_pending_banner(inputs)
	if (locale === "sw") return sw_pending_banner(inputs)
	if (locale === "nl") return nl_pending_banner(inputs)
	return en_pending_banner(inputs)
});